(function($) {
  $(document).ready(function(){

      $("[dataid=lotSizeHelper_-1]").hide();
      $("i.box-close").first().hide();
      $(".summaryrow").hide();

      $("#stampDutyVariesDiv").hide();

      $("body").on("click", "#viewsamplecontract-btn",function(){
         $("#viewsamplecontract").show();
         if(window.result){
              updateContractNote();
         }
      });

      var modal = document.getElementById('viewsamplecontract');

      // When the user clicks anywhere outside of the modal, close it
      $(window).click(function(event) {
          if (event.target == modal) {
              $("#viewsamplecontract").hide();
          }
      });

      $(window).on('scroll', function(){
          adjustFooter();
      });

      $("body").on("click", "[dataid^=showcharges]", function(){
          var panelVisible = $(this).parents('.brokerage-charges-finals').find('.brokerage-summary-row').is(':visible'),
              txt          = panelVisible ? 'SHOW CHARGES BREAKUP' : 'HIDE CHARGES BREAKUP',
              iconClass    = panelVisible ? 'showicon' : 'hideicon';
          $(this).find('div').text(txt);
          $(this).find('i').attr("class", iconClass);
          $(this).parents('.brokerage-charges-finals').find('.brokerage-summary-row').slideToggle();
      });

      function searchResultClickHandler(el) {
          var activeTextbox = $(el).parents('upstox-search').find('input[type=text]');
          var activeDropdown = $(el).parents('upstox-search').find('.search_results_holder');
          window.activeId = $(el).parents(".upstoxSearchModule").attr("dataid").match(/\d+$/)[0];
          window.activeId = "-" +window.activeId;

          if( window.result.exchange == 'NSE' || window.result.exchange == 'BSE'){
              if( window.result.exchange == 'NSE' && window.result.series =="FO"){
                  activeTextbox.val('NFO '+window.result.symbol);
              }
              else{
                  activeTextbox.val(window.result.exchange+' '+window.result.symbol+' '+window.result.series);
              }
          }
          else if((window.result.exchange == 'NCD' || window.result.exchange == 'BCD' || window.result.exchange == 'MCX')){
              if(window.result.series =="FO"){
                  activeTextbox.val(window.result.exchange+' '+window.result.symbol);
              }
              else{
                  activeTextbox.val(window.result.exchange+' '+window.result.symbol+' '+window.result.series);
              }
          }
          else{
              activeTextbox.val(window.result.symbol+' '+window.result.series+' '+window.result.exchange);
          }

          activeDropdown.removeClass('show').addClass('hide');
          var exchangeToken = window.result.exchangeToken;
          updateCharges(false, window.activeId);

          $.getJSON("https://bom1.upstox.com/v0/instruments/details?tokens="+exchangeToken, function(json){
              window.instrumentDetails = json;
              var closePrice = window.instrumentDetails[exchangeToken].cp;
              var boardLot = window.instrumentDetails[exchangeToken].board_lot;
              updatePrices(window.activeId, closePrice);
              updateCharges(false, window.activeId, closePrice);
              triggerInstrumentChanged(window.activeId, closePrice, boardLot);
          });

      }

      window.searchResultClickHandler = searchResultClickHandler;

      // $("body").on("click", "li.result" , function(){
      //     console.log(this);
      //     searchResultClickHandler(this);
      // });
      // document.addEventListener('click', function(e) {
      //     if (e.target.matches('li.result')) {
      //         console.log(e.target);
      //     }
      // });

      $("#bState").change(function() {
          changeStateStampDuty($("#bState").val());
      });

      window.activeId = "-1";

      $("[dataid=buyPrice_" + window.activeId +"]").keyup(function() {
          extractNumber($("[dataid=buyPrice_" + window.activeId +"]")[0]);
          updateCharges(false, window.activeId);
      });

      $("[dataid=sellPrice_" + window.activeId).keyup(function() {
          extractNumber($("[dataid=sellPrice_" + window.activeId +"]")[0]);
          updateCharges(false, window.activeId);
      });
      $("[dataid=qty_" + window.activeId).keyup(function() {
          extractNumber($("[dataid=qty_" + window.activeId +"]")[0]);
          updateCharges(false, window.activeId);
      });

      setTimeout(function(){
          loadScripDetails(window.activeId);
      },1000);



  });
})( jQuery );
